// Aurora ambiental de fondo — lo que el Liquid Glass difumina detrás.
// Fija, detrás de todo (z-index 0). El contenido va con z-index >= 1.
export default function Aurora() {
  return (
    <div className="ic-aurora" aria-hidden="true">
      <div className="ic-blob b1" />
      <div className="ic-blob b2" />
      <div className="ic-blob b3" />
    </div>
  );
}
